import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
	getSupportQuestions,
	getSupportQuestionById,
	getMyTickets,
	getTicketById,
	voteOnQuestion,
	getVotesByQuestion,
	getUserVote,
} from 'src/apis/support';

export const useGetSupportQuestions = (
	category?: string,
	positionId?: string,
	companyId?: string,
	batchId?: number,
	supportCategory?: string,
	supportSubcategory?: string,
) => {
	return useQuery(
		['getSupportQuestions', category, positionId, companyId, batchId, supportCategory, supportSubcategory],
		() => getSupportQuestions(category, positionId, companyId, batchId, supportCategory, supportSubcategory),
		{
			enabled: true,
			staleTime: 5 * 60 * 1000, // 5 minutes
		},
	);
};

export const useGetSupportQuestionById = (id: string) => {
	return useQuery(['getSupportQuestionById', id], () => getSupportQuestionById(id), {
		enabled: !!id,
	});
};

export const useGetMyTickets = (status?: string, category?: string) => {
	return useQuery(['getMyTickets', status, category], () => getMyTickets(status, category), {
		enabled: true,
		refetchInterval: 30000,
		refetchOnWindowFocus: true, // So jobseeker sees updated tickets when returning to tab
	});
};

export const useGetTicketById = (id: string) => {
	return useQuery(['getTicketById', id], () => getTicketById(id), {
		enabled: !!id,
		refetchInterval: 15000, // Refetch every 15s while ticket is open for live updates
		refetchOnWindowFocus: true, // Refetch when jobseeker returns to tab so admin replies show without manual refresh
		refetchOnMount: true, // Always refetch when opening ticket so latest messages (e.g. admin replies) are loaded
	});
};

export const useVoteOnQuestion = () => {
	const queryClient = useQueryClient();
	return useMutation(['voteOnQuestion'], voteOnQuestion, {
		onSuccess: (data, variables) => {
			// Refetch votes for the question
			queryClient.refetchQueries(['getVotesByQuestion', variables.supportQuestionId]);
			queryClient.refetchQueries(['getUserVote', variables.supportQuestionId]);
		},
	});
};

export const useGetVotesByQuestion = (questionId: string) => {
	return useQuery(['getVotesByQuestion', questionId], () => getVotesByQuestion(questionId), {
		enabled: !!questionId,
	});
};

export const useGetUserVote = (questionId: string) => {
	return useQuery(['getUserVote', questionId], () => getUserVote(questionId), {
		enabled: !!questionId,
	});
};


